import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/layout/layout-dashboard';
import { motion } from 'framer-motion';

const steps = [
  {
    emoji: "🧱",
    title: "Création de votre programme",
    description:
      "Nous transformons vos contenus RH en un module d'accueil personnalisé pour vos candidats.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/Design%20sans%20titre%20(24).png",
  },
  {
    emoji: "📝",
    title: "Ouverture des recrutements",
    description:
      "On co-construit les mappings RH et une fiche de poste ultra-précise qui servira de base au ciblage et àl'atterissage de vos candidats.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/MappingRH.svg",
  },
  {
    emoji: "🎯",
    title: "Sourcing intelligent",
    description:
      "Nos experts activent réseau, annonces, CVthèques et Ads selon vos contraintes.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/Mockup-ordinateur.webp",
  },
  {
    emoji: "🔍",
    title: "Préqualification rigoureuse",
    description:
      "Chaque profil passe par notre filtre humain + tech pour valider l'adéquation poste.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/Campagnes-recrutement-marseille.webp",
  },
  {
    emoji: "🧪",
    title: "Test de personnalité",
    description:
      "Les candidats réalisent un test Trimoji. Objectif : évaluer le matching et préparer l'intégration.",
    image:"https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/testrh.webp",
  },
  {
    emoji: "📞",
    title: "Entretien consultant",
    description:
      "Un de nos experts RH valide le profil à l'oral avant transmission.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/Mockup-ordinateur-_1_.webp",
  },
  {
    emoji: "🧑‍💼",
    title: "Entretien client",
    description:
      "Vous reprenez la main avec toutes les cartes en main : analyse + feedback RH.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/pilotage%20des%20recrutements.webp",
  },
  {
    emoji: "🚀",
    title: "Préboarding personnalisé",
    description:
      "Le candidat accède à votre parcours d'intégration digitalisé, conçu sur mesure.",
    image: "https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/Onboarding%20marseille.png",
  },
  {
    emoji: "💬",
    title: "Rapport d'étonnement",
    description:
      "Au bout d'un mois, il vous livre ses ressentis pour ajuster votre culture et onboarding.",
    image: "/images/etape9.webp",
  },
];

export default function TimelineRecrutementPage() {
  return (
    <Layout>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <div className="relative py-24 px-6 bg-neutral-50">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-16 text-neutral-900">
          🏋️‍♂️ Timeline Recrutement
        </h1>

        <div className="relative mx-auto w-full max-w-5xl">
          <div className="absolute left-1/2 top-0 w-2 bg-gradient-to-b from-[#d03484] to-[#d47254] h-full transform -translate-x-1/2 rounded-full" />

          {steps.map((step, index) => {
            const isLeft = index % 2 === 0;
            return (
              <motion.div
                key={index}
                className={`relative flex flex-col md:flex-row mb-20 items-center ${isLeft ? 'md:flex-row-reverse' : ''}`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="w-full md:w-1/2 px-6 flex justify-center">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="rounded-xl w-full max-w-md shadow-xl"
                  />
                </div>

                <div className="relative w-full md:w-1/2 px-6 mt-10 md:mt-0">
                  <div className="absolute left-1/2 top-0 w-10 h-10 bg-white border-4 border-[#d03484] rounded-full transform -translate-x-1/2 -translate-y-1/2 z-10 flex items-center justify-center text-xl">
                    {step.emoji}
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-xl">
                    <h3 className="text-xl font-bold mb-2 text-neutral-900">{step.title}</h3>
                    <p className="text-neutral-700 text-base leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}